import { useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import SelectDropDown from "../SelectDropdown";
import Loader from "../Loader";
import {
  getScrewFetchStatus,
  getScrewProperties,
} from "../../store/selectors/ScrewSelectors";
import {
  createScrewPropertyAction
} from "../../store/actions/ScrewsActions";
import { ScrewPropertiesResponse } from "../../types/ScrewTypes";

const NUMERIC_PROPERTIES = ["total_length", "head_diameter"];

interface ScrewDropdownPropTypes {
  selectedScrewProperty: string | undefined;
  onChooseScrewProperty: (event: any) => void;
  propertyType?: string;
}

const ScrewDropdownProps = (props: ScrewDropdownPropTypes) => {
  const {
    selectedScrewProperty,
    onChooseScrewProperty,
    propertyType,
  } = props;

  const dispatch = useAppDispatch();
  const screwFetchStatus = useAppSelector(getScrewFetchStatus);
  const screwProperties = useAppSelector(getScrewProperties) as ScrewPropertiesResponse | null;

  const isScrewDataFetching = screwFetchStatus === "loading";

  const createTextFilter = (filter: string) => {
    const property = screwProperties?.items?.find(x => x.propertyname === propertyType);
    const filterExists = property?.categoricalvalues?.includes(filter);
    if (!filterExists && property) {
      dispatch(createScrewPropertyAction({ propertyId: property.propertyid, propertyValue: filter }));
    }
  };

  const property = screwProperties?.items?.find(item => item.propertyname === propertyType);
  const options = useMemo(() => {
    const values = property?.categoricalvalues || [];
    const sortedValues = NUMERIC_PROPERTIES.includes(propertyType || '')
      ? [...values].sort((a, b) => parseFloat(a) - parseFloat(b))
      : [...values].sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));

    return [
      { value: "", label: "None" },
      ...sortedValues.map(value => ({ value, label: value }))
    ];
  }, [property, propertyType]);

  if (isScrewDataFetching) {
    return <Loader />;
  }

  const label = propertyType?.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());

  return (
    <div className="row bottom-30">
      <SelectDropDown
        hasCreateNewFilter={true}
        createFilter={createTextFilter}
        onChange={onChooseScrewProperty}
        options={options}
        label={label}
        selectedOption={selectedScrewProperty || ""}
      />
    </div>
  );
};

export default ScrewDropdownProps;
